
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const HeavyCranesPage = lazy(() => import('../pages/cranes/heavy/page'));
const LightCranesPage = lazy(() => import('../pages/cranes/light/page'));
const CraneDetailPage = lazy(() => import('../pages/cranes/detail/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/cranes/heavy',
    element: <HeavyCranesPage />,
  },
  {
    path: '/cranes/light',
    element: <LightCranesPage />,
  },
  {
    path: '/cranes/:category/:id',
    element: <CraneDetailPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
